import styled from 'styled-components'

interface MessageTextProps {
    dangerouslySetInnerHTML?: {
        __html: string
    }
}

export const Text = styled.div<MessageTextProps>`
    p {
        margin: 8px 0;
        &:first-child {
            margin-top: 0;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }

    ul {
        margin: 8px 0;
        padding-left: 20px;
        list-style-type: circle;
    }

    li {
        margin: 4px 0;
    }

    a {
        color: ${(props) => props.theme.colors.brand.primary};
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    b {
        font-weight: bold;
    }

    i {
        font-style: italic;
    }

    br {
        display: block;
        margin: 4px 0;
    }
`
